import { ComponentProps } from 'react';

import { ReactComponentType } from 'strapi/component/types';
import { AiWritingToolChildStrapiPage } from 'strapi/page/aiWritingToolChildPage';
import { CreateSubUseCaseStrapiPage } from 'strapi/page/createSubUseCasePage';
import { CreateUseCaseStrapiPage } from 'strapi/page/createUseCasePage/types';
import { MockupChildStrapiPage } from 'strapi/page/mockupChildPage';
import { PageType, PageTypes } from 'strapi/page/types';
import { ReactComponentBuildResponse } from 'strapi/types';

import RelatedLinks from './RelatedLinks';

export const collectRelatedLinksParams = (
  pageType: PageType,
  page: PageTypes
): ReactComponentBuildResponse<typeof RelatedLinks> | undefined => {
  if (!('relatedLinks' in page) || !page.relatedLinks) {
    return undefined;
  }

  let links: ComponentProps<typeof RelatedLinks>['links'] = [];

  if (pageType === PageType.CreateUseCasePage) {
    const createUseCasePage = page as CreateUseCaseStrapiPage;
    links = createUseCasePage.use_case?.sub_use_cases
      ?.filter((x) => !!x?.name && !!x.create_sub_use_case_page?.path)
      .map((x) => ({
        label: x.name,
        url: x.create_sub_use_case_page?.path,
      }));
  }

  if (pageType === PageType.CreateSubUseCasePage) {
    const createSubUseCasePage = page as CreateSubUseCaseStrapiPage;
    links = createSubUseCasePage.sub_use_case?.use_case?.sub_use_cases
      ?.filter(
        (x) =>
          !!x?.name &&
          !!x.create_sub_use_case_page?.path &&
          x.create_sub_use_case_page?.path !== page.path
      )
      .map((x) => ({
        label: x.name,
        url: x.create_sub_use_case_page?.path,
      }));
  }

  if (pageType === PageType.MockupChildPage) {
    const mockupChildPage = page as MockupChildStrapiPage;
    links = mockupChildPage.mockup_parent_page.mockup_child_pages
      ?.filter((x) => !!x?.path && x.path !== mockupChildPage.path)
      .map((x) => ({
        label: x.descriptiveName ?? x.slug,
        url: x.path,
      }));
  }

  if (pageType === PageType.AiWritingToolChildPage) {
    const aiWritingToolChildPage = page as AiWritingToolChildStrapiPage;
    links = aiWritingToolChildPage.ai_writing_parent_page.ai_writing_child_pages
      ?.filter((x) => !!x?.path && x.path !== aiWritingToolChildPage.path)
      .map((x) => ({ label: x.descriptiveName ?? x.slug, url: x.path }));
  }

  if (page.relatedLinks.extraLinks?.length) {
    links = links.concat(page.relatedLinks.extraLinks);
  }

  if (!links || links?.length === 0) {
    return undefined;
  }

  return {
    component: ReactComponentType.RelatedLinks,
    props: {
      title: page.relatedLinks.title,
      links: links,
    },
  };
};
